<i18n src="@/locales/modules/DeviceAccessoryTranslate.json"></i18n>

<template>
	<div id="logs-todo-kpi" class="vs-con-loading__container comments">
		<div class="comments__list-item">
			<div v-for="(tag, idx) in tags" :key="idx">
				<h6 class="font-bold mb-2 mt-4">{{ tag.name }}</h6>
				<div v-for="(kpi, idx) in kpis[tag.key]" :key="`log-todo-${idx}`" class="pb-3 ">
					<div class="flex justify-between border-solid border px-4 py-3 rounded border-gray-5 cursor-pointer">
						<p @click.stop="showDetail(kpi)" class="text-base">{{ kpi.name }}</p>
						<div class="flex">
							<p>{{ $helper.numFormat(kpi.current_hrs) }}/{{ $helper.numFormat(kpi.maintain_hrs) }}</p>
							<DeviceKpiContextMenu
								type="vertical"
								:accessory="kpi"
								@onClickEdit="editDataKpi"
								@onClickDelete="showDeleteAccessoryConfirm"
								@onClickResetKpiHour="data => $emit('onClickResetKpiHour', data)"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>

		<KpiDetailDialog
			v-if="isShowKpiDialog"
			:kpi="kpiDetail"
			:device="device"
			:isSidebarActive="isShowKpiDialog"
			@closeSidebar="toggleDetailSidebar"
			@onClickEdit="editDataKpi"
			@onClickDelete="showDeleteAccessoryConfirm"
			@onClickCreateTodo="handleClickCreateTodoWithAccessory"
			@onClickCreateRequest="handleClickCreateRequestWithAccessory"
		/>
	</div>
</template>

<script>
import DeviceKpiContextMenu from "../../views/apps/cbs/device/DeviceKpiContextMenu";
import KpiDetailDialog from "./KpiDetailDialog";
import { groupBy, mapKeys } from "lodash";
export default {
	name: "ListDeviceKpi",
	components: { DeviceKpiContextMenu, KpiDetailDialog },
	props: {
		device: {
			type: Object
		}
	},
	computed: {
		kpis() {
			const t = groupBy(this.$store.state.deviceManagement.kpiDetails, item => (item.tags[0] ? item.tags[0].id : -1));
			return t || [];
		},
		tags() {
			const t = groupBy(this.$store.state.deviceManagement.kpiDetails, item => (item.tags[0] ? item.tags[0].id : -1));
			let tags = [];
			mapKeys(t, (val, key) => {
				tags.push({ key: key, name: key !== "-1" ? val[0].tags[0].name : this.$t("Others") });
			});
			return tags;
		}
	},
	data() {
		return {
			isShowKpiDialog: false,
			kpiDetail: {},
			isDialogActiveLocal: false,
			kpiReset: null
		};
	},
	methods: {
		editDataKpi(kpi) {
			const data = { ...kpi, device: this.device };
			this.$emit("editDataKpi", data);
		},
		showDeleteAccessoryConfirm(kpi) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: this.$t("Notify.DeleteConfirm"),
				accept: () => this.deleteAccessory(kpi),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel")
			});
		},
		handleClickCreateTodoWithAccessory(kpi) {
			const _accessory = { id: kpi.id, type: this.$constant.RELATION_MODELS.ACCESSORY, display_name: kpi.name };
			this.$emit("onClickCreateTodo", _accessory);
		},
		handleClickCreateRequestWithAccessory(kpi) {
			const _accessory = { id: kpi.id, type: this.$constant.RELATION_MODELS.ACCESSORY };
			this.$emit("onClickCreateRequest", _accessory);
		},
		async deleteAccessory(kpi) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("deviceManagement/deleteKpiDetail", kpi.pivot_id);
				this.toggleDetailSidebar(false);
				this.$helper.notifySuccess({
					context: this,
					options: {
						text: this.$t("DeleteAccessorySuccessful", { accessoryTypeName: this.accessoryTypeName(kpi) })
					}
				});
			} catch (error) {
				console.error("Error deleteAccessory", error);
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		toggleDetailSidebar(val) {
			this.isShowKpiDialog = val;
		},
		showDetail(item) {
			this.kpiDetail = item;
			this.toggleDetailSidebar(true);
		},
		accessoryTypeName() {
			return this.$t("Kpi").toLowerCase();
		}
	}
};
</script>
